import { render, staticRenderFns } from "./GenericTemplateTemplate.vue?vue&type=template&id=1a87b9a8&"
import script from "./GenericTemplateTemplate.vue?vue&type=script&lang=js&"
export * from "./GenericTemplateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports